import { connectWithStore } from '@common/connectWithStore';

import { getFeatures } from '@react/Pages/AccountSettingsPage/PricingPlanPage/features';
import {
  getState,
  getMonthlyPlans,
  getYearlyPlans,
  cancelDowngrade,
} from '@redux/ducks/account/pricingPlan/pricingPlans';
import { showForm } from '@redux/ducks/account/pricingPlan/changePricingPlan';
import { PlanPeriod } from '@redux/ducks/account/pricingPlan/interfaces';
import { PricingPlans } from './PricingPlans';

const mapStateToProps = state => {
  const { currentPlan, planPeriod, canSwitchPeriod } = getState(state);

  const monthlyPlans = getMonthlyPlans(state);
  const yearlyPlans = getYearlyPlans(state);

  const paymentPlans = planPeriod === PlanPeriod.Monthly ? monthlyPlans : yearlyPlans;
  const isYearly = canSwitchPeriod && planPeriod === PlanPeriod.Yearly;

  return {
    features: getFeatures(t),
    currentPlan,
    paymentPlans,
    isYearly,
    monthlyPaymentPlans: monthlyPlans,
  };
};

const mapStateToDispatch = {
  onConfirm: showForm,
  onCancel: cancelDowngrade,
};

export const PricingPlansContainer = connectWithStore(mapStateToProps, mapStateToDispatch)(PricingPlans);
